import React from 'react';
import { Card } from 'components/Card';
import { iconPlusWhite, iconWhiteTrash } from "assets/icons"
import { FormikErrors } from 'formik';
import { 
  Col,
  Container,
  Content,
  Grid,
  IconContainer,
  Row,
} from './styles';
import { ContactProps, useContacts } from './useContacts';
import { Loading } from 'components/Loading';
import { PlaceHolderNotExists } from 'components/PlaceholderNotExists';
import { SelectModified } from 'components/SelectModified';
import { InputFormField } from 'components/InputFormField';
import { Button } from 'components/Button';
import { Footer } from 'components/Footer';
import { Title } from 'components/Title';
import { Badge } from 'components/Badge';
import facebook from 'assets/social-media-icons/facebook.svg';
import twitter from 'assets/social-media-icons/twitter.svg';
import youtube from 'assets/social-media-icons/youtube.svg';
import instagram from 'assets/social-media-icons/instagram.svg';
import tiktok from 'assets/social-media-icons/tiktok.svg';

interface SocialMediaDictionary {
  [name: string]: string,
}

const socialMedias:SocialMediaDictionary = {
  'facebook': facebook,
  'twitter': twitter,
  'youtube': youtube,
  'instagram': instagram,
  'tiktok': tiktok,
}

export const Contact: React.FC = () => {
  const {
    loading,
    hasError,
    inputsValues,
    contactTypes,
    socialMediaTypes,
    changedFields,
    touched,
    errors,
    handleChange,
    handleAddContact,
    handleRemoveContact,
    handleFormSubmit,
    handleFormDiscard,
  } = useContacts();
  
  if (loading) {
    return <Loading/>
  }

  if (hasError) {
    return (
      <PlaceHolderNotExists title="Erro ao tentar conectar com o servidor" />
    )
  }

  return (
    <Container>
      <Content>
        <Card
          title="Contato"
          labelButton="Adicionar contato"
          typeBtn="blue"
          iconButton={iconPlusWhite}
          onClick={handleAddContact}
          hasButton
        >
          <Grid>
            {
              inputsValues.contacts.map((_, index) => {
                let contactErrors = errors.contacts?.[index] as FormikErrors<ContactProps>;
                return <Row key={index} className="contacts">
                  <Col>
                    <SelectModified
                      options={
                        contactTypes?.map((contactType) => {
                          return {
                            label: contactType.contactType ?? '',
                            value: contactType.contactTypeId
                          }
                        }) ?? []
                      }
                      name={`contacts[${index}].contactTypeId`}
                      label="Contato"
                      value={inputsValues.contacts[index].contactTypeId}
                      onChange={handleChange}
                      error={
                        touched.contacts?.[index]?.contactTypeId &&
                        !!contactErrors?.contactTypeId
                      }
                      errorMessage="Contato inválido"
                      block={true}
                    />
                  </Col>
                  <Col>
                    <InputFormField
                      name={`contacts[${index}].title`}
                      label="Título"
                      value={inputsValues.contacts[index].title}
                      onChange={handleChange}
                      error={
                        touched.contacts?.[index]?.title &&
                        !!contactErrors?.title
                      }
                      mensageError="Título inválido"
                      marginBotton={'0'}
                      block={true}
                    />
                  </Col>
                  <Col>
                    <InputFormField
                      name={`contacts[${index}].contact`}
                      label="Contato"
                      value={inputsValues.contacts[index].contact}
                      onChange={handleChange}
                      error={
                        touched.contacts?.[index]?.contact &&
                        !!contactErrors?.contact
                      }
                      mensageError="Contato inválido"
                      marginBotton={'0'}
                      block={true}
                    />
                  </Col>
                  <Col className={"d-flex"}>
                    <Button
                      label=""
                      typeBtn="danger"
                      onlyIcon={true}
                      icon={iconWhiteTrash}
                      className="remove-contact"
                      onClick={() => handleRemoveContact(index)}
                    />
                  </Col>
                </Row>
              })
            }
          </Grid>
        </Card>

        <Card title="Redes sociais oficiais">
          <Grid
            numberOfColumns={2}
          >
            {
              socialMediaTypes?.map((socialMedia, index) => {
                return (
                  <Row key={index} className="contacts">
                    <IconContainer
                      src={socialMedias[socialMedia.contactType?.toLowerCase() ?? '']}
                      style={{marginRight: '16px'}}
                    />
                    <InputFormField
                      name={`socialMedias[${index}].contact`}
                      label={socialMedia.contactType}
                      value={inputsValues.socialMedias[index]?.contact}
                      onChange={handleChange}
                      block={true}
                      marginBotton={'0'}
                    />
                  </Row>
                )
              })
            }
          </Grid>
        </Card>
      </Content>

      <Footer>
        <Title elementHTML="strong" text="Campos atualizados:" className="tag" />

        {changedFields.map((item: string) => (item ? <Badge value={item ?? ''} key={item} /> : null))}
        
        <Button type="button" label="Descartar" size="medium" typeBtn="outline" onClick={handleFormDiscard} />
        <Button type="button" label="Atualizar dados" size="medium" typeBtn="blue" onClick={handleFormSubmit} />

      </Footer>
    </Container>
  );
}
